/* eslint-disable react-hooks/exhaustive-deps */
import { ChoiceGroup, Stack, TextField } from "@fluentui/react";
import { useEffect, useState } from "react";
import {
  IIpercPeligroPost,
  INuevoPeligro,
} from "../../../Interfaces/IIpercBase";
import HelpersIpercBase, {
  CODIGO,
  validaIntervalo,
  validaOpcion,
  _indicadorByChoiceKey,
} from "../../../utils/helpers/HelpersIpercBase";

const borderSmoke = { border: "Solid 1px #ccc" };

function NuevoPeligro(props: INuevoPeligro) {
  const INITIAL_MODEL: IIpercPeligroPost = {
    actividadId: props.actividadId,
    medida: { codigoOpcion: CODIGO.BAJO, indicador: 25 },
    riesgo: { codigoOpcion: CODIGO.BAJO, indicador: 25 },
  };

  const [model, setModel] = useState<IIpercPeligroPost | null>(INITIAL_MODEL);
  const [medidaInd, setMedidaInd] = useState<number>(25);
  const [RiesgoInd, setRiesgoInd] = useState<number>(25);

  const [choiceMedidaKey, setChoiceMedidaKey] = useState(CODIGO.BAJO);
  const [choiceRiesgoKey, setChoiceRiesgoKey] = useState(CODIGO.BAJO);

  const _handleTexfileChange = (
    { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name, value } = target as HTMLInputElement;
    setModel({
      ...model,
      [name]: value,
    });
  };

  const _handleTexfildRiesgoChange = (
    { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name, value } = target as HTMLInputElement;
    setModel({
      ...model,
      riesgo: { ...model?.riesgo, [name]: value },
    });
  };
  const _handleTexfildMedidaChange = (
    { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name, value } = target as HTMLInputElement;
    setModel({
      ...model,
      medida: { ...model?.medida, [name]: value },
    });
  };

  const _handleTexfileNumberRiesgoChange = (
    { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name, value } = target as HTMLInputElement;
    let ind = validaIntervalo(parseInt(value));
    setRiesgoInd(ind);
    setChoiceRiesgoKey(validaOpcion(ind));

    setModel({
      ...model,
      riesgo: {
        ...model?.riesgo,
        [name]: !isNaN(ind) ? ind : 1,
        codigoOpcion: validaOpcion(ind),
      },
    });
  };
  const _handleTexfileNumberMedidaChange = (
    { target }: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue?: string
  ) => {
    const { name, value } = target as HTMLInputElement;
    let ind = validaIntervalo(parseInt(value));
    setModel({
      ...model,
      medida: {
        ...model?.medida,
        [name]: !isNaN(ind) ? ind : 1,
        codigoOpcion: validaOpcion(ind),
      },
    });
    setChoiceMedidaKey(validaOpcion(ind));
    setMedidaInd(ind);
  };

  const _onChangeChoiceMedida = (val, op) => {
    if (op) {
      setChoiceMedidaKey(op.key);
      setMedidaInd(_indicadorByChoiceKey(op.key));
      setModel({
        ...model,
        medida: {
          ...model?.medida,
          codigoOpcion: op.key,
          indicador: _indicadorByChoiceKey(op.key),
        },
      });
    }
  };

  const _onChangeChoiceRiego = (val, op) => {
    if (op) {
      setChoiceRiesgoKey(op.key);
      setRiesgoInd(_indicadorByChoiceKey(op.key));
      setModel({
        ...model,
        riesgo: {
          ...model?.riesgo,
          codigoOpcion: op.key,
          indicador: _indicadorByChoiceKey(op.key),
        },
      });
    }
  };

  // useEffect(() => {
  //     setModel({ ...model, actividadId: props.actividadId })
  // }, [props.actividadId]);

  useEffect(() => {
    props.ModelPOST({ ...model });
    // console.log("POST : ", model)
  }, [model]);

  return (
    <>
      <div className="ms-Grid-col ms-lg12">
        <br />
        <TextField
          name="peligro"
          resizable={false}
          style={borderSmoke}
          label="Peligro"
          // placeholder="Nombre Peligro *"
          onChange={_handleTexfileChange}
          borderless
        />
      </div>
      <br />
      <br />
      <div className="ms-Grid-col ms-lg12">
        <TextField
          {...HelpersIpercBase.TextFieldMultilineProps}
          name="nombre"
          onChange={_handleTexfildRiesgoChange}
          label="Riesgo"
        />
        <Stack
          verticalAlign="end"
          horizontal
          className="ms-depth-4 ms-bgColor-gray10"
          padding={8}
        >
          <div className="ms-Grid-col ms-lg6">
            <ChoiceGroup
              name="Riesgo"
              defaultSelectedKey="03"
              options={HelpersIpercBase.IPERC_CHOICE_OPTIONS}
              styles={{ flexContainer: { display: "flex" } }}
              selectedKey={choiceRiesgoKey}
              onChange={_onChangeChoiceRiego}
            />
          </div>
          <div className="ms-Grid-col ms-lg6">
            <TextField
              {...HelpersIpercBase.TextFieldNumberProps}
              id="riesgo"
              name="indicador"
              onChange={_handleTexfileNumberRiesgoChange}
              value={RiesgoInd.toString()}
              onBlur={() => {
                if (isNaN(RiesgoInd)) setRiesgoInd(1);
              }}
            />
          </div>
        </Stack>
      </div>
      <br />
      <br />
      <br />
      <div className="ms-Grid-col ms-lg12">
        <TextField
          {...HelpersIpercBase.TextFieldMultilineProps}
          label="Medida Control"
          name="nombre"
          onChange={_handleTexfildMedidaChange}
        />
        <Stack
          verticalAlign="end"
          horizontal
          className="ms-depth-4 ms-bgColor-gray10"
          padding={8}
        >
          <div className="ms-Grid-col ms-lg6">
            <ChoiceGroup
              options={HelpersIpercBase.IPERC_CHOICE_OPTIONS}
              styles={{ flexContainer: { display: "flex" } }}
              selectedKey={choiceMedidaKey}
              onChange={_onChangeChoiceMedida}
            />
          </div>
          <div className="ms-Grid-col ms-lg6">
            <TextField
              {...HelpersIpercBase.TextFieldNumberProps}
              id="medida"
              name="indicador"
              onChange={_handleTexfileNumberMedidaChange}
              value={medidaInd.toString()}
              onBlur={() => {
                if (isNaN(medidaInd)) setMedidaInd(1);
              }}
            />
          </div>
        </Stack>
      </div>
    </>
  );
}

export default NuevoPeligro;
